"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatusBadge = TransactionStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../table");
function TransactionStatusBadge(props) {
    var _a = props.status, status = _a === void 0 ? "" : _a;
    var PAID_STATUSES = ["PAID", "SUCCEEDED"];
    var FAILED_STATUSES = ["REQUIRES_PAYMENT_METHOD", "FAILED", "CANCELED"];
    if (PAID_STATUSES.includes(status))
        return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: "green-soft", children: "Paid" });
    if (FAILED_STATUSES.includes(status))
        return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: "red", children: "Failed" });
    var label = status ? status.charAt(0) + status.slice(1).toLowerCase().replace(/_/g, " ") : "—";
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: "gray", children: label });
}
